<ng-container>
    <h3>{{ 'invest.datatables.minValue.shortLabel' | translate }}</h3>
    <form #limitsForm="ngForm">
        <ng-container *ngFor="let item of simulation.itemsDetail; index as i">
            <mat-form-field *ngIf="item.isEditable">
                <mat-label>{{ item.text.fullLabel }}</mat-label>
                <input matInput type="text" name="amount{{i}}"
                    [ngModel]="item.minValue | formatAmount: 'rounded': false "
                    (ngModelChange)="item.minValue = parseValue($event)"
                    onclick="this.select()">
                <span matSuffix> €</span>
            </mat-form-field>
        </ng-container>
    </form>
</ng-container>

<table>
    <thead>
        <tr>
            <th></th>
            <th *ngFor="let year of simulation.years">
                {{ year.year }}
            </th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let item of simulation.itemsDetail"
            [ngClass]="{
                important: item.code === budgetResCode || item.code === afmCode,
                child: item.parentCode
            }">
            <td> {{ item.text.fullLabel }} </td>
            <td *ngFor="let year of simulation.years; index as i" [ngClass]="{executed: !year.isEstimated}">
                <span [ngClass]="{errorCell: checkError(year, item.code, item.minValue)}">
                    {{ getItemValue(year, item.code) | formatAmount }}
                </span>
            </td>
        </tr>
    </tbody>
</table>
